import { useCompanyStore } from '@/shared/stores/CompanyStore'
import { useDynamicDialog } from '@/shared/composables/UseDynamicDialog'
import UpdateCompanyFormDialog from '@/features/companies/dialogs/UpdateCompanyFormDialog.vue'
import UpdateCompanyVideoFormDialog from '@/features/companies/dialogs/UpdateCompanyVideoFormDialog.vue'
import GenerateSandboxDialog from '@/features/companies/dialogs/GenerateSandboxDialog.vue'

type Nullish<T> = T | null | undefined

export function useCompanyActions() {
  const companyStore = useCompanyStore()
  const dialog = useDynamicDialog()

  function openInTeamleader(teamleaderCompanyId: Nullish<string>) {
    if (!teamleaderCompanyId) {
      return
    }
    window.open(`https://focus.teamleader.eu/companies/${teamleaderCompanyId}`, '_blank')
  }

  function loginToPortal(companyId: number) {
    void companyStore.forwardToPortal(companyId)
  }

  function openUpdateDialog(
    companyId: number,
    options?: {
      redirectBack?: boolean,
      onUpdate?: () => void | Promise<void> 
    },
  ) {
    dialog.open(UpdateCompanyFormDialog, {
      data: {
        companyId,
        redirectBack: options?.redirectBack,
      },
      emits: options?.onUpdate
        ? { onUpdateCompany: options.onUpdate }
        : undefined,
    })
  }

  function openUpdateVideoDialog(
    companyId: number,
    options?: { onUpdate?: () => void | Promise<void> },
  ) {
    dialog.open(UpdateCompanyVideoFormDialog, {
      data: { companyId },
      emits: options?.onUpdate
        ? { onUpdateCompanyVideo: options.onUpdate }
        : undefined,
    })
  }

  function openGenerateSandboxDialog(companyId: number, companyName: string) {
    dialog.open(GenerateSandboxDialog, {
      data: {
        companyId,
        companyName, 
      },
    })
  }

  return {
    openInTeamleader,
    loginToPortal,
    openUpdateDialog,
    openUpdateVideoDialog,
    openGenerateSandboxDialog,
  }
}
